import {observer} from 'mobx-react';
import LieuTimeNote from './LieuTimeNote';

const RegularCell = observer(({model}) => {
  return (
    <div>
      <div>{model.regular}</div>
      <LieuTimeNote lieuTime={model.straightLieuTime}/>
    </div>
  );
});

export default RegularCell;
